export const sl = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Nazaj",
        save: "Shrani",
        saved: "Shranjeno",
        cancel: "Prekliči",
        close: "Zapri",
        accessDenied: "Dostop zavrnjen",
        noExportPermission: "Nimate dovoljenja za izvoz teh podatkov o avtomobilu.",
        delete: "Izbriši",
        downgrade: "Zmanjšaj",
        downgradeConfirm: "Ste prepričani, da želite preiti na brezplačni načrt?",
        edit: "Uredi",
        loading: "Nalagam...",
        confirm: "Potrdi",
        processing: "Obdelujem...",
        history: "Zgodovina",
        currentCar: "Trenutni Avto",
        purchasedCarTitle: "Nakup Avtomobila",
        initialCost: "Začetni Strošek",
        done: "Končano",
        ok: "V redu",
        error: "Napaka",
        errorSaving: "Napaka pri shranjevanju podatkov",
        mandatoryFieldsError: "Prosimo, pravilno izpolnite vsa obvezna polja.",
        search: "Išči",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Neveljavna oblika e-pošte",
        today: "Danes",
        car: "Avto",
        all: "Vse",
        deleteConfirm: "Izbriši",
        unsavedChangesTitle: "Nepotrjene Spremembe",
        unsavedChangesMessage: "Želite shraniti spremembe pred odhodom?",
        dontSave: "Ne shrani",
        additionalOptions: "Dodatne možnosti",
        add: "Dodaj",
        fileTooLarge: "Datoteka je prevelika. Največja velikost je {limit} MB.",
        storageFull: "Presežen je limit shranjevanja. Največje shranjevanje je {limit} MB.",
        dailyUploadLimit: "Dosežen dnevni limit nalaganja ({limit} datotek/dan). Poskusite znova jutri.",
        hourlyUploadLimit: "Dosežen urni limit nalaganja ({limit} datotek/uro). Poskusite znova čez eno uro.",
        fileCountLimit: "Največ {limit} datotek je dovoljenih na element.",
        emailParseLimitReached: "Dosežen je limit obdelave e-pošte. Prosimo, nadgradite svoj načrt ali obdelajte ročno.",
        emailLimitText: "Dosežen je limit obdelave e-pošte.",
        monthlyEmailScans: "Mesečni Pregledi E-pošte",
        lifetimeEmailScans: "Življenjski Pregledi E-pošte",
        monthlyFileScans: "Mesečni Pregledi Računov",
        lifetimeFileScans: "Življenjski Pregledi Računov",
        fileLimitText: "Dosežen je limit pregledov računov.",
        planFreeTier: "Brezplačni načrt",
        planProTier: "Pro načrt",
        uploadFailed: "Nalaganje ni uspelo",
        attachments: "Priloge",
        limitsAndUsage: "Omejitve in Uporaba",
        addresses: "naslovi",
        emailCopied: "E-poštni naslov je kopiran!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Vključeno",
        proOnly: "Samo PRO",
        month: "mes",
        openInNewTab: "Odpri v novem zavihku",
        menu: "Meni",
        home: "Domov",
        monthsShort: {
            0: "Jan",
            1: "Feb",
            2: "Mar",
            3: "Apr",
            4: "Maj",
            5: "Jun",
            6: "Jul",
            7: "Avg",
            8: "Sep",
            9: "Okt",
            10: "Nov",
            11: "Dec",
        },
    },
    carMetadata: {
        bodyType: "Tip Karoserije",
        drivetrain: "Pogon",
        transmission: "Menjalnik",
        bodyTypes: {
            sedan: "Sedan",
            hatchback: "Hatchback",
            wagon: "Kombi (Estate)",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupe",
            convertible: "Kabriolet",
            pickup: "Pickup",
            van: "Van / Minivan",
            commercial: "Komercialno",
            other: "Drugo",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Drugo",
        },
        transmissions: {
            not_specified: "-",
            manual: "Ročni",
            automatic: "Avtomatski",
            cvt: "CVT",
            other: "Drugo",
        },
        otherLabel: "Drugo (določite)",
        mileageLabel: "Prevoženi Kilometri",
    },
    auth: {
        welcome: "Dobrodošli",
        welcomeBack: "Spet dobrodošli",
        signIn: "Prijavi se",
        signInWithGoogle: "Prijavi se z Google-om",
        signOut: "Odjavi se",
        magicLinkDesc: "Prejmite čarobno povezavo v vaši e-pošti",
        magicLinkSent: "Čarobna povezava poslana!",
        magicLinkCheckEmail: "Preverite svojo e-pošto in kliknite povezavo za prijavo.",
        emailAddress: "E-poštni naslov",
        getMagicLink: "Pridobi čarobno povezavo",
        sending: "Pošiljam...",
        linkSent: "Povezava poslana",
        orContinueWith: "Ali nadaljujte z",
        googleAccount: "Google Račun",
        newUserNote: "Nov tukaj? Vaš račun bo ustvarjen samodejno ob prvi uspešni prijavi.",
        magicLinkError: "Pošiljanje čarobne povezave ni uspelo. Prosimo, preverite svojo e-pošto in poskusite znova.",
        genericError: "Prišlo je do napake. Prosimo, poskusite znova.",
        projectDescription: "Spremljajte stroške, vzdrževanje in zgodovino vašega avtomobila na enem mestu.",
        loginError: "Prijava ni mogoča",
        loggingIn: "Prijavljam se...",
        authenticating: "Avtentikacija...",
        authenticatingDesc: "Prosimo, počakajte, medtem ko zagotavljamo vašo sejo.",
    },
    settings: {
        title: "Nastavitve",
        systemPreferences: "Sistemske Nastavitve",
        appSettings: "Nastavitve Aplikacije",
        dangerZone: "Tveganje",
        theme: "Tema",
        language: "Jezik Vmesnika",
        currency: "Valuta",
        units: "Enote",
        distanceUnit: "Enota razdalje",
        volumeUnit: "Enota prostornine",
        expenseTypes: "Vrste stroškov",
        expenseTypesDesc: "Upravljanje kategorij",
        categories: "Kategorije",
        exportData: "Izvozi podatke",
        exportDesc: "Prenesi celovit CSV",
        importData: "Uvozi podatke",
        importDesc: "Obnovi iz varnostne kopije CSV",
        deleteAccount: "Izbriši račun",
        deleteAccountDesc: "Trajno odstrani vse podatke",
        enableSync: "Omogoči sinhronizacijo",
        enableSyncDesc: "Sinhroniziraj podatke med napravami",
        account: "Račun",
        accountPlan: "Načrt računa",
        carsUsage: "Avtomobili",
        carsLimitReached: "Dosežen limit avtomobilov",
        storageSize: "Velikost shrambe",
        emailScans: "E-poštni skeni",
        fileScans: "Skeni računov",
        plans: "Načrti",
        currentlyPlan: "Trenutno",
        upgradePlan: "Nadgradnja",
        manageSubscription: "Upravljanje naročnine",
        nextPayment: "Naslednje plačilo",
        endsOn: "Se konča",
        adminConsole: "Admin konzola",
        systemControl: "Nadzor sistema",
        customCategories: "Prilagojene kategorije in oznake",
        interfaceTheme: "Tema vmesnika",
        light: "Svetla",
        dark: "Temna",
        timezone: "Časovni pas",
        timezoneDesc: "Uporablja se za načrtovana e-poštna opomnika",
        timeFormat: "Format časa",
        timeFormat24h: "24-urni (14:30)",
        timeFormat12h: "12-urni (2:30 popoldne)",
        kilometers: "kilometri (km)",
        miles: "milje (mi)",
        liters: "litri (l)",
        gallons: "gali (gal)",
        accountManagement: "Upravljanje računa",
        contactUs: "Kontaktirajte nas",
        contactDesc: "Za predloge, zahteve po funkcijah in vprašanja",
        logOut: "Odjava",
        logOutConfirmTitle: "Odjava",
        logOutConfirmMessage: "Ali ste prepričani, da se želite odjaviti iz svojega računa?",
        keepAccount: "Obdrži račun",
        deleteAccountConfirmTitle: "Izbriši račun",
        deleteAccountConfirmMessage: "Ali ste prepričani, da želite trajno izbrisati svoj račun in vse povezane podatke o avtomobilih? Te akcije ni mogoče razveljaviti.",
        deletePermanently: "Trajno izbriši",
        deleting: "Brisanje...",
        contactSupport: "Kontaktirajte podporo",
        messageSent: "Sporočilo poslano!",
        feedbackThanks: "Hvala za vaše povratne informacije. Cenimo vaš prispevek in ga bomo preučili.",
        backToSettings: "Nazaj na nastavitve",
        subjectLabel: "Zadeva",
        messageLabel: "Sporočilo",
        subjectPlaceholder: "O čem gre?",
        messagePlaceholder: "Povejte nam o svojem predlogu, zahtevi po funkcijah ali vprašanju...",
        enterSubjectAlert: "Prosimo, vnesite zadevo",
        enterMessageAlert: "Prosimo, vnesite sporočilo",
        sendFailedAlert: "Pošiljanje sporočila ni uspelo. Poskusite znova pozneje.",
    },
    export: {
        title: "Izvozi podatke",
        generatePDF: "Ustvari PDF",
        carInformation: "Informacije o avtomobilu",
        editInfo: "Uredite informacije spodaj, da prilagodite svoj izvoz",
        editInfoHint: "Lahko odstranite ali spremenite katera koli polja, ki jih ne želite vključiti",
        filters: "Filtri",
        expenseTypes: "Vrste stroškov",
        includeNotes: "Vključi opombe",
        includeImages: "Vključi datoteke",
        hideDisabled: "Skrij onemogočene elemente",
        itemsCount: "{total} elementov, {selected} izbranih",
        selectAll: "Izberi vse",
        deselectAll: "Odstrani izbiro vseh",
        expenses: "Stroški",
        notes: "Opombe",
        spareParts: "Rezervni deli",
        images: "Slike",
        files: "Datoteke",
        summary: "Povzetek",
        totalExpenses: "Skupni stroški",
        totalItems: "Skupno elementov",
        generatedOn: "Ustvarjeno dne",
        noItemsSelected: "Noben element ni izbran za izvoz",
        noItemsAvailable: "Noben element ni na voljo za izvoz",
        generating: "Ustvarjanje PDF...",
        downloadPDF: "Prenesi PDF",
        pdfFileName: "{carName}_izvoz_{date}.pdf",
        reportTitle: "Poročilo o stroških avtomobila",
        exportButton: "Izvozi",
        generateCSV: "Generiraj CSV",
        formatSelectorTitle: "Izberite format",
        formatSelectorMsg: "Prosimo, izberite format izvoza",
        proFeatureExportTitle: "Pro funkcija: Izvoz podatkov",
        proFeatureExportDesc: "Nadgradite na PRO, da izvozite svojo zgodovino avtomobila v PDF.",
        exportRestrictedPopup: "Izvoz podatkov je na voljo samo za Pro uporabnike.",
        allTypes: "Vse vrste",
        statistics: "Statistika",
        driven: "Prevoženo",
        since: "Od",
        averageCost: "Povprečni strošek",
        perKm: "na km",
        perMile: "na miljo",
        period: "Obdobje",
        dateFrom: "Od",
        dateTo: "Do",
        allTime: "Počisti filter",
        periodHint: "Če ni izbranega obdobja — so prikazani vsi stroški",
        noExpenses: "Nobeni stroški ne ustrezajo filtrom",
        expensesSection: "Stroški",
        attachmentsSection: "Priloge",
        imagesCount: "{count} slik",
        pdfsCount: "{count} PDF-jev",
        includeParts: "Vključi rezervne dele",
        pageLabel: "Stran",
    },
    expenses: {
        title: "Stroški",
        newExpense: "Nov strošek",
        editExpense: "Uredi strošek",
        openExpense: "Odpri vnos stroška",
        details: "Podrobnosti o strošku",
        selectType: "Izberi vrsto",
        selectTypePlaceholder: "Izberi vrsto stroška...",
        shortDescriptionPlaceholder: "Kratka opis...",
        expenseTitle: "Naslov",
        logEntryTitleLabel: "Naslov zapisa (neobvezno)",
        defaultTitlePlaceholder: "Privzeti naslov - {type}",
        autoTitlePlaceholder: "Bodo samodejno izpolnjeni na podlagi izbranih vrst",
        carDataTitle: "Podatki o avtomobilu",
        defaultTitlePrefix: "Privzeti naslov bo -",
        addAnother: "Dodaj še eno vrsto stroška",
        addAnotherHint: "Če ta zapis vključuje več vrst stroškov, jih lahko vse dodate tukaj, da zagotovite natančno statistiko.",
        carValueDescription: "Ocenjena tržna vrednost avtomobila v tem trenutku.",
        type: "Vrsta",
        date: "Datum",
        amount: "Znesek",
        totalAmount: "Skupaj",
        splitCosts: "Razdeliti stroške?",
        combineCosts: "Združi stroške",
        amountWork: "Delo",
        amountParts: "Deli",
        mileage: "Prevoženi kilometri",
        carValue: "Vrednost avtomobila",
        description: "Opis",
        detailedDescription: "Podroben opis",
        electricity: "Elektrika",
        fuelType: "Vrsta goriva",
        fuelTypeOptions: {
            petrol: "Bencin",
            diesel: "Dizel",
            lpg: "LPG",
            electricity: "Elektrika",
        },
        carData: "Podatki o avtomobilu",
        images: "Datoteke",
        addImages: "Dodaj datoteke",
        addImagesPDFs: "Dodaj slike ali PDF-je",
        deleteExpense: "Izbriši strošek",
        deleteConfirm: "Ste prepričani, da želite izbrisati ta strošek?",
        saveSuccess: "Strošek uspešno shranjen",
        thisExpense: "Ta strošek",
        stats: {
            annual: "Letno",
            allTime: "Vse čase",
            avgMonth: "Povprečno/mesec",
            costPer: "Strošek/",
            noExpenses: "Še ni stroškov",
            dragToReorder: "Povlecite ročaj za preureditev",
        },
        expensesFound: "Ustvarjeno",
        noExpensesFound: "Ni najdenih stroškov.",
        noDescription: "Brez opisa",
        imagesCount: "Slike ({count})",
        deleteImageTitle: "Izbriši sliko",
        deleteImageConfirm: "Ste prepričani, da želite izbrisati to sliko? Te akcije ni mogoče razveljaviti.",
        typeLabels: {
            fuel: "Gorivo",
            car_wash: "Pranje",
            repairs: "Popravila",
            maintenance: "Vzdrževanje",
            parts: "Rezervni deli",
            insurance: "Zavarovanje",
            inspection: "Inšpekcija",
            tyres: "Pnevmatike",
            parking: "Parkiranje",
            electricity: "Elektrika",
            taxes: "Davki",
            other: "Drugo",
            info: "Informacije",
            service_maintenance: "Vzdrževanje",
            service_repair: "Popravilo",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Servis",
            selectSubtype: "Izberi vrsto storitve",
            maintenance: "Vzdrževanje",
            repair: "Popravilo",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Ponavljajoči strošek",
        repeatToggle: "Ponovi ta strošek",
        repeatFrequency: "Pogostost",
        monthly: "Mesečno",
        startDate: "Datum začetka",
        nextDate: "Naslednji vnos bo ustvarjen",
        endDate: "Datum konca",
        noEndDate: "Brez datuma konca",
        copyOptions: "Možnosti kopiranja",
        copyTitle: "Kopiraj naslov zapisa",
        copyLocation: "Kopiraj lokacijo",
        copyDescription: "Kopiraj opis",
        active: "Aktiven",
        status: "Status",
        managedByRepeat: "Ta strošek je del ponavljajoče se sekvence.",
        placeholder: "Tukaj lahko nastavite samodejno ponavljanje za ta strošek, če se redno pojavlja z enakim zneskom.",
        deleteRepeat: "Izbriši ponavljanje",
        deleteRepeatConfirm: "Ste prepričani, da želite ustaviti in izbrisati to ponavljajočo se sekvenco? Prihodnji vnosi ne bodo ustvarjeni. Prejšnji vnosi bodo ostali.",
        relatedEntries: "Vnosi v tej sekvenci",
        stopRepeat: "Ustavi ponavljanje",
        isRepeating: "Ponavljajoče se",
        noTerm: "Neskončno",
        until: "Zadnji vnos bo ustvarjen",
        summaryCopy: "Sistem bo kopiral",
        simulate: "Simuliraj generacijo naslednjega vnosa",
        simulateSuccess: "Uspešno simulirana generacija naslednjega vnosa",
        simulateNoDate: "Ni več datumov za generiranje (dosežen končni datum)",
    },
    onboarding: {
        title: "Nastavi profil",
        welcome: "Dobrodošli!",
        subtitle: "Prilagodite svojo izkušnjo vožnje.",
        currency: "Valuta",
        preferredCurrency: "Željena valuta",
        distUnit: "Enota razdalje",
        volUnit: "Enota prostornine",
        complete: "Dokončaj nastavitev",
    },
    cars: {
        unitChangeWarningTitle: "Opozorilo o spremembi enot",
        unitChangeWarningMessage: "Sprememba teh enot ne bo pretvorila vaših obstoječih podatkov. Vsi zgodovinski zapisi bodo ostali natančno tako, kot so bili vneseni.",
        unitChangeWarningConfirm: "Razumem",
        title: "Garaža",
        carAdmins: "Administratorji avtomobilov",
        sharedWithMe: "Deli z mano",
        manageAdmins: "Upravljaj administratorje",
        adminEmail: "E-pošta administratorja",
        addAdmin: "Dodaj administratorja",
        addAdminPlaceholder: "npr. prijatelj@email.com",
        removeAdmin: "Odstrani",
        removeAdminConfirm: "Ste prepričani, da želite odstraniti tega administratorja?",
        adminAdded: "Administrator dodan",
        adminRemoved: "Administrator odstranjen",
        removeMyAccess: "Odstrani moj dostop",
        removeMyAccessConfirm: "Ste prepričani, da želite odstopiti dostop do tega avtomobila?",
        myAccessRemoved: "Dostop odstranjen",
        noAdminsYet: "Še ni dodanih administratorjev.",
        adminInfoText: "Administratorji lahko dodajajo in urejajo stroške, opombe in rezervne dele, vendar ne morejo izbrisati samega avtomobila.",
        newCar: "Dodaj Avto",
        carNotFound: "Avto Ni Najden",
        carNotFoundDesc: "Zahtevani avto ne obstaja ali pa nimate dostopa.",
        accessDenied: "Dostop Zavrnjen",
        accessDeniedDesc: "Ta avto je zaseben in ni javno dostopen.",
        backToHome: "Nazaj na Domov",
        adminRestricted: "Dostop Omejen",
        adminRestrictedDesc: "Samo pooblaščeni administratorji lahko dostopajo do te konzole. Prosimo, vrnite se v glavno aplikacijo.",
        returnHome: "Vrni se Domov",
        editCar: "Uredi Avto",
        name: "Ime Avtomobila",
        model: "Model",
        year: "Leto",
        plate: "Številka Registracije",
        vin: "VIN Številka",
        mileage: "Trenutna Prevožena Razdalja",
        initialMileage: "Začetna Prevožena Razdalja",
        engineType: "Tip Motorja",
        tapToChangeIcon: "Tapnite za spremembo ikone",
        chooseIcon: "Izberite Ikono",
        imageTab: "Slika",
        iconTab: "Ikona",
        chooseColor: "Izberite Barvo",
        chooseEmoji: "Izberite Emoji",
        uploadImage: "Naložite Sliko",
        clickToBrowse: "Kliknite za iskanje datotek",
        currentCarIcon: "Trenutna ikona avtomobila",
        changeImage: "Spremeni Sliko",
        zoom: "Povečaj",
        rotate: "Zavrti",
        removeChangeImage: "Odstrani / Spremeni Sliko",
        selectIcon: "Izberite Ikono",
        cropAndSave: "Obreži & Shrani",
        displayName: "Prikazno Ime",
        displayNamePlaceholder: "npr. Moj Vikend Avto",
        makeLabel: "Proizvajalec *",
        modelLabel: "Model *",
        yearLabel: "Leto *",
        fuelTypeLabel: "Tip Goriva *",
        licensePlateLabel: "Registrska Številka",
        vinLabel: "VIN",
        notesLabel: "Opombe (neobvezno)",
        notesPlaceholder: "npr. 1.6 TDI, 85kW, 1588cc, baterija 62kWh, AWD, itd.",
        publicAccess: "Naredite avto javno dostopen",
        publicAccessDesc: "Drugi lahko vidijo ta avto preko deljene povezave",
        shareLocations: "Dovoli, da si ogledate tudi dodane lokacije",
        shareLocationsDesc: "Omogočite to, da bodo lokacije avtomobilov vidne v javnem pogledu",
        deleteCar: "Izbriši Avto",
        deleteCarTitle: "Izbriši Avto",
        deleteCarConfirm: "Ste prepričani, da želite izbrisati '{name}'? Te akcije ni mogoče razveljaviti.",
        noCars: "Ni avtomobilov v vaši garaži",
        addFirstCarNote: "Začnite svojo pot z dodajanjem prvega vozila za sledenje stroškom.",
        addVehicle: "Dodaj Vozilo",
        myVehicles: "Moja Vozila",
        favorites: "Priljubljeni",
        deleteConfirm: "Ste prepričani, da želite izbrisati ta avto? Vsi povezani stroški bodo izbrisani.",
        deleteFailed: "Izbris avtomobila ni uspel",
        saveFailed: "Shranjevanje podatkov o avtomobilu ni uspelo",
        adminActions: "Dejanja Administratorja",
        importCsv: "Uvozi CSV",
        clearData: "Počisti Podatke",
        distanceUnitLabel: "Enota Razdalje",
        volumeUnitLabel: "Enota Volumna",
        currencyLabel: "Valuta",
        boughtAt: "Datum Nakupa",
        purchasePrice: "Nakupna Cena",
        purchaseMileage: "Nakupna Prevožena Razdalja",
        createPurchaseRecord: "Samodejno ustvarite zapis o nakupni zgodovini",
        makePlaceholder: "npr. BMW",
        modelPlaceholder: "npr. X5",
        platePlaceholder: "npr. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Te informacije bodo ustvarile začetni zapis 'Informacije' v vaši zgodovini z navedenimi podatki.",
        availableTypes: "Na voljo Tipi",
        dragToReorder: "Povlecite za preureditev",
        requestTypeNote: "Če potrebujete drug tip - ",
        requestTypeAction: "nas obvestite!",
        emailProcessingTitle: "Obdelava E-pošte",
        emailInstructions: "Preusmerite svoje račune na spodnji naslov. Izvlekli bomo podatke in samodejno ustvarili stroške.",
        recentEmails: "Prejete E-pošte",
        viewAllEmails: "POGLEJ VSE ({count})",
        noEmailsReceived: "Še ni prejetih e-pošt.",
        analysisResult: "Rezultat Analize",
        vehicleInfo: "Informacije o Vozilu",
        preferences: "Nastavitve",
        purchaseHistory: "Zgodovina Nakupov",
        emailProcessing: "Obdelava E-pošte",
        publicAccessTitle: "Javni Dostop",
        expenseTypesTitle: "Vrste Stroškov",
        adminActionsTitle: "Dejanja Administratorja",
        enterPurchaseDateAlert: "Prosimo, vnesite datum nakupa",
        allowedSenderEmails: "Dovoljeni E-poštni Naslovi Pošiljateljev",
        allowedEmailsDesc: "Dodajte e-poštne naslove, ki so dovoljeni za pošiljanje računov temu avtomobilu. Največ 5 naslovov.",
        noAllowedEmails: "Nobeni dovoljeni e-poštni naslovi niso dodani.",
        emailAlreadyAdded: "Ta e-poštni naslov je že dovoljen za ta avto.",
        maxAllowedEmailsReached: "Dosežen je največji dovoljen limit e-pošt.",
        addAllowedEmailPlaceholder: "Dodajte dovoljen e-poštni naslov...",
        ownerEmail: "Lastnik",
        onlyOwner: "samo lastnik",
        defaultAllowed: "Vedno dovoljeno",
        carLimitReachedTitle: "Dosežen Limit Avtomobilov",
        carLimitReachedMessage: "Vaš {plan} načrt dovoljuje {limit} avto(ov). Že imate {current}. Pojdite v nastavitve, da si ogledate svoje limite ali nas kontaktirajte za nadgradnjo.",
        carLimitGoToSettings: "Pojdite v Nastavitve",
        archivedCars: "Arhivirani",
        archiveCar: "Arhiviraj avto",
        unarchiveCar: "Obnovi avto",
        sellDate: "Datum prodaje",
        sellPrice: "Cena prodaje",
        sellMileage: "Prevoženi kilometri ob prodaji",
        archiveConfirm: "Ali ste prepričani, da želite arhivirati ta avto?",
        archiveInstructions: "Arhiviranje avta pomeni, da več ni vaš ali ga ne vzdržujete več. Prosimo, navedite podrobnosti o prodaji za statistiko. To bo avto naredilo samo za branje. Polja spodaj lahko še vedno urejate kasneje.",
        archivedBadge: "Arhivirano",
        saleDetails: "Podrobnosti o prodaji",
        saleDetailsNote: "Podrobnosti o prodaji se uporabljajo za statistiko. Lahko jih posodobite, če je potrebno.",
        archiveDetailsNotFillable: "Prosimo, izpolnite vsa polja za arhiviranje avta",
        emailAddressWillBeAvailableAfterSave: "E-poštni naslov bo na voljo po shranjevanju avta.",
        proFeatureAdminTitle: "Pro funkcija: Upravitelji avtomobilov",
        proFeatureAdminDesc: "Dodajte druge uporabnike, ki lahko ogledajo in upravljajo te podatke o avtomobilu.",
        proFeatureEmailTitle: "Pro funkcija: Dodatni pošiljatelji",
        proFeatureEmailDesc: "Dodajte druge dovoljene e-poštne naslove, s katerih lahko pošiljate račune za ta avtomobil.",
        estimatedMileage: "Ocenjena prevožena razdalja",
        summaryFrequencyLabel: "Pogostost povzetkov",
        summaryFrequencyOptions: {
            none: "Izklopljeno",
            monthly: "Mesečno",
            semiAnnually: "Polletno",
            annually: "Letno",
        },
        healthProfilePrompt: "Izpolnite svoj zdravstveni profil za natančno analizo!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Bencin",
        diesel: "Dizel",
        hybrid: "Hibrid",
        electric: "Električni",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Trend prevoženih kilometrov",
        title: "Statistika",
        allYears: "Vsa leta",
        totalSpent: "Skupaj porabljeno",
        spentIn: "Porabljeno v {year}",
        perMonth: "na mesec",
        overall: "skupaj",
        vsPrev12m: "vs pret. 12m",
        rolling12m: "Zadnjih 12m",
        byType: "Po vrsti",
        byMonth: "Po mesecu",
        byYear: "Po letu",
        noData: "Brez podatkov za to leto",
        mostExpensive: "Najdražje",
        top: "Najboljše",
        untitled: "Brez naslova",
        assetAnalysis: "Analiza vrednosti in stroškov",
        burnNote: "* 'Skupni stroški' vključujejo tako porabljeni denar kot ocenjen padec vrednosti avta.",
        carMarketValue: "Tržna vrednost avta",
        cumulativeCosts: "Kumulativni stroški",
        totalBurn: "Skupni stroški (stroški + amortizacija)",
        entries: "vnosov",
        avgPrice: "Povprečna cena",
        consumption: "Poraba",
        price: "Cena",
        fuelPriceTrend: "Trend cen goriv",
        spendingTrend: "Trend porabe",
        costPerKmTrend: "Strošek na 1 km",
        costPerMileTrend: "Strošek na 1 miljo",
        serviceTrendsTitle: "Trendi storitev",
        expensesOnMap: "Stroški na zemljevidu",
        visitsCountLabel: "obiskov",
        locationsSummary: "Povzetek lokacij",
        locationsCountLabel: "krajih",
        noLocationsFoundTitle: "Še ni lokacij",
        noLocationsFoundDesc: "Dodajte lokacije v svoje zapise, da jih vidite na zemljevidu.",
        addMileageData: "Dodaj prevožene kilometre",
        missingMileageInfo: "Nedovolj podatkov za izračun stroškov na razdaljo. Dodajte vsaj 2 merjenja prevoženih kilometrov v tem obdobju (ali eno pred tem obdobjem).",
        mileageModal: {
            title: "Dodaj manjkajoče prevožene kilometre",
            description: "Za natančen izračun stroškov na razdaljo za {year} potrebujemo podatke o prevoženih kilometrih na začetku in koncu leta.",
            startOfYear: "Začetek leta (1. jan)",
            endOfYear: "Konec leta (31. dec)",
            currentMileage: "Trenutni prevoženi kilometri",
            placeholder: "Vnesite prevožene kilometre...",
            save: "Shrani podatke",
            foundNearby: "Najdeno v bližini ({date}): {value} {unit}",
            useExisting: "Uporabi to",
        },
        proAnalysis: "Pro analiza",
        detailedAnalysis: "Podrobna analiza",
        upgradeToSee: "Nadgradite, da vidite →",
    },
    tabs: {
        dashboard: "Nadzorna plošča",
        expenses: "Stroški",
        stats: "Statistika",
        locations: "Lokacije",
        gallery: "Datoteke",
        parts: "Deli",
        notes: "Opombe",
        repair: "Način popravila",
        'repair-switch': "Preklop avtomobila",
    },
    repairAnalysis: {
        title: "Analiza odločitev o popravilu",
        ownershipLength: "Dolžina lastništva",
        currentValue: "Trenutna vrednost",
        valueOutdated: "Vrednost je lahko zastarela",
        addValueToEnable: "Dodajte trenutno vrednost avta, da omogočite analizo",
        totalInvested: "Skupaj investirano",
        totalInvestedSub: "Nakupna cena + popravila",
        totalExcludesFuel: "izključuje gorivo / elektriko",
        fuelLabelFuelOnly: "Skupaj goriva",
        fuelLabelEnergyOnly: "Skupaj energije",
        fuelLabelHybrid: "Skupaj goriva in energije",
        fuelTypeFuel: "gorivo",
        fuelTypeEnergy: "elektrika",
        fuelTypeHybrid: "gorivo in elektrika",
        fuelTotalLabel: "Skupaj gorivo/energija:",
        projectionMode: "Način projekcije",
        projectionModes: {
            lastYear: "Na podlagi prejšnjega leta",
            average: "Zgodovinsko povprečje",
            trend: "Trend (linearno)",
        },
        brakeAssumption: "Vzdrževanje vključuje ocenjen 3-letni cikel zavor",
        repairBuffer: "Vključuje tveganje za popravila na podlagi starosti",
        yearLabel: "leto",
        totalInvestedDesc: "Nakupna cena + vsi popravki",
        repairToValue: "Popravilo do vrednosti (12m)",
        repairToValueExplain: "Popravila €{cost} proti vrednosti avta €{value}. Pod 20% je zdravo; nad 50% je visoko tveganje.",
        ownershipPressure: "Pritisk lastništva",
        ownershipPressureExplain: "Skupni pritisk stroškov: popravila €{cost} + izguba vrednosti proti €{value}. Nad 35% signalizira finančni stres.",
        investmentGap: "Investicijska vrzel",
        investmentGapExplain: "Skupaj investirano €{invested} minus trenutna vrednost €{value}. To prikazuje, koliko ste doslej 'izgubili' na lastništvu.",
        investmentGapDesc: "Skupaj investirano - trenutna vrednost",
        repairExpenses12m: "Stroški popravila 12m",
        calculatedYearlyMileage: "Izračunana letna prevožena razdalja: {km} km",
        calculatedYearlyRepairs: "Izračunani letni popravki: {amount}",
        set: "Nastavi",
        plannedRepairCost: "Načrtovani stroški popravila",
        whatIfTitle: "Kaj če zdaj porabite {amount}?",
        updatedScore: "Posodobljena ocena",
        updatedVerdict: "Posodobljen sklep",
        howIsItCalculated: "Kako je to izračunano?",
        usedLifespan: "Uporabljeno: {usage}% pričakovane življenjske dobe",
        remainingLifespan: "Preostala: ~{km} km",
        estimatedLifespan: "Ocenjena življenjska doba: {km} km",
        lifecycle_stage_early: "Zgodnja življenjska doba – nizko tveganje za velike okvare",
        lifecycle_stage_mid: "Srednja življenjska doba – normalna obraba",
        lifecycle_stage_late: "Pozna življenjska doba – povečano tveganje za popravila",
        lifecycle_stage_end: "Konec pričakovane življenjske dobe – visoko tveganje za velike popravke",
        calculationExplanation: "Analiza uporablja nakupno ceno vašega vozila, nedavne stroške popravila in ocenjeno trenutno vrednost za izračun finančnega zdravja. Visoki stroški popravila v primerjavi z vrednostjo avta ali hitro amortizacijo bodo znižali oceno.",
        confidenceLabel: "Zaupanje",
        confidenceLevel: {
            high: "Visoko",
            medium: "Srednje",
            low: "Nizko",
        },
        mentalFactorsTitle: "Izboljšajte natančnost s svojimi izkušnjami",
        mentalFactorsCTA: "Hiter pregled (30 sek)",
        mentalFactorsSurveyTitle: "Vaše izkušnje",
        mentalFactorsSurveyDesc: "Odgovorite na 3 hitra vprašanja, da prilagodite svojo oceno.",
        q1: "Ali vaš avto ustreza vašim potrebam?",
        q1Help: "Prostor, udobje, funkcije",
        q2: "Ali uživate v vožnji svojega avta?",
        q2Help: "Vizualno, udobje, občutek",
        q3: "Ali vas skrbi za nepričakovane okvare?",
        q3Help: "Skrbi glede zanesljivosti",
        q4: "Je ta avto za družino in dolge poti?",
        q4Help: "Prednost varnosti in zanesljivosti",
        factorsTitle: "Dejavniki ocene",
        factorsDesc: "Oglejte si, kaj vpliva na vašo oceno",
        newCarComparison: "Primerjava novih avtomobilov",
        newCarComparisonDesc: "Primerjajte svoje trenutne mesečne stroške z nakupom novega avtomobila.",
        modeLeasing: "Leasing",
        modeFullPrice: "Polna cena",
        downPayment: "Akontacija",
        leaseYears: "Trajanje (leta)",
        monthlyPayment: "Mesečno plačilo",
        carPrice: "Polna cena avtomobila",
        ownershipYears: "Načrtovana lastništvo (leta)",
        insuranceMonthly: "Mesečna CASCO / Zavarovanje",
        currentMonthlyCost: "Trenutni strošek avta",
        newCarMonthlyCost: "Strošek novega avtomobila",
        newCarCheaper: "Nov avto je cenejši za: {amount} / mesec",
        newCarMoreExpensive: "Nov avto je dražji za: {amount} / mesec",
        newCarSameCost: "Stroški so točno enaki.",
        advancedSettings: "Napredne nastavitve",
        yearlyMaint: "Letno vzdrževanje (€)",
        tyres3Yrs: "Pnevmatike / 3 leta (€)",
        depreciation5Yrs: "Amortizacija (5 let %)",
        newCarYear: "Leto novega avtomobila",
        cumulativeCosts: "Kumulativni stroški (projekcija)",
        comparisonByYear: "Primerjava po letih",
        currentCarLabel: "Trenutni avto",
        newCarLabel: "Nov avto",
        resaleValue: "Vrednost pri ponovni prodaji",
        startupCosts: "Začetni stroški (rabljeni avto)",
        inspection: "Pregled pred nakupom",
        initialMaintenance: "Prvo vzdrževanje + olja",
        registration: "Registracija / Stroški",
        total: "Skupaj",
        currentCarTitle: "Trenutni avto",
        newCarTitle: "Potencialni avto",
        upfrontInvestment: "Začetna naložba",
        monthlyReality: "Dejanski mesečni strošek",
        depreciationShort: "Amortizacija",
        howCalculated: "Kako je to izračunano?",
        deltaMonthly: "Mesečna razlika",
        deltaUpfront: "Začetna razlika",
        surveyMeanings: {
            practical: {
                1: "Sploh ne",
                2: "Slaba ujemanje",
                3: "Povprečno",
                4: "Dobro ujemanje",
                5: "Popolno ujemanje",
            },
            joy: {
                1: "Frustrirajoče",
                2: "Dolgočasno",
                3: "Povprečno",
                4: "Prijetno",
                5: "Zelo",
            },
            worry: {
                1: "Nisem zaskrbljen",
                2: "Rahlo zaskrbljen",
                3: "Zaskrbljen",
                4: "Zelo zaskrbljen",
                5: "Prepričan sem, da se bom vsak trenutek pokvaril",
            },
        },
        verdicts: {
            KEEP: "Finančno smiselno obdržati",
            borderline: "Na meji – natančno spremljajte",
            sell: "Visoko finančno tveganje – prodaja je lahko smiselna",
        },
        factors: {
            trendInc: "Naraščajoči trend",
            trendIncDesc: "Stroški popravil naraščajo v primerjavi z lanskim letom.",
            lowDepreciation: "Prednost nizke amortizacije",
            lowDepreciationDesc: "Starejši/cenejši avtomobili izgubljajo manj vrednosti skozi čas.",
            stableRepairs: "Stabilna popravila",
            stableRepairsDesc: "Vaši stroški popravil so stabilni ali se zmanjšujejo.",
            noHistoricalData: "Brez podatkov starejših od 6 mesecev.",
            lifecycle_stage: "Faza življenjskega cikla vozila",
            high_risk_phase: "Faza visokega tveganja",
            high_risk_phase_desc: "Kombinacija pozne faze življenjskega cikla in naraščajočih stroškov popravil kaže na visoko tveganje.",
            lowCostKm: "Učinkovitost stroškov na KM",
            lowCostKmDesc: "Splošna učinkovitost delovanja tega avtomobila je odlična.",
            lowFixedCosts: "Nizki fiksni stroški",
            lowFixedCostsDesc: "Vaši fiksni stroški (davki, zavarovanje) so nizki.",
            usage: "Letna uporaba",
            usageDesc: "Razdalja, prevožena v zadnjih 12 mesecih.",
            accidentMinor: "Manjša nesreča",
            accidentMinorDesc: "Kozmetične poškodbe ali manjša popravila.",
            structuralDamage: "Strukturna škoda",
            structuralDamageDesc: "Težave s konstrukcijo ali okvirjem drastično znižujejo vrednost.",
            aiLifespanNearEnd: "Konec pričakovane življenjske dobe",
            aiLifespanAging: "Staranje komponent",
            aiLifespanGood: "Prednost nizke kilometrine",
            aiLifespanDesc: "Na podlagi AI ocenjene tipične življenjske dobe za ta model.",
            aiUpcomingRepairs: "Prihajajoča popravila (napoved AI)",
            aiUpcomingRepairsDesc: "AI napoveduje velike okvare komponent kmalu na podlagi kilometrine.",
            ownershipFatigue: "Utrujenost od lastništva",
            ownershipFatigueLong: "Dolgoročno lastništvo pogosto vodi do mentalne pripravljenosti na drugačno vozilo.",
            ownershipFatigueShort: "Prvotna pristranskost lastništva ustvarja močnejšo nagnjenost k ohranjanju avtomobila.",
            family_priority: "Družina in dolge poti",
            replacement_comparison: "Primerjava zamenjav",
            none: "Noben",
            surface: "Površina",
            minor: "Manjši",
            moderate: "Zmeren",
            severe: "Hudo",
            structural: "Strukturno",
            major: "Večji",
            critical: "Kritično",
            full: "Polno",
            improveLabel: "Kaj bi to izboljšalo:",
            info_original_price: "Približna cena tega avtomobila, ko je bil nov. Pomaga oceniti stabilnost vrednosti. Starejši avtomobili z nižjo preostalo vrednostjo so finančno varnejši.",
            info_current_value: "Koliko bi ga lahko prodali danes. Uporablja se za preverjanje, ali so popravki velik odstotek vrednosti avtomobila, kar signalizira slabo naložbo.",
            info_yearly_mileage: "Višja prevožena razdalja povečuje obrabo. Nizka prevožena razdalja lahko znatno podaljša življenjsko dobo avtomobila.",
            info_estimated_repairs: "Stalni strošek vzdrževanja avtomobila. Visoki letni stroški zmanjšujejo privlačnost ohranjanja avtomobila.",
            info_planned_repairs: "Znane prihajajoče popravke. Simulira takojšnji pritisk na vašo odločitev.",
            info_ownership_years: "Kako dolgo imate ta avto? To vpliva na psihološko utrujenost lastništva in začetno pristranskost kupca.",
            info_rust: "Kritično dolgoročno tveganje. Strukturna rja zmanjšuje varnost. Huda rja naredi prodajo boljšo možnost.",
            info_crashes: "Strukturne nesreče vplivajo na varnost in zanesljivost. Prav tako znatno zmanjšujejo vrednost pri ponovni prodaji.",
            info_repaint: "Označuje prejšnje poškodbe ali kozmetične popravke. Majhen vpliv, razen če so bili skriti globlji problemi.",
            info_unresolved: "Skriti prihodnji stroški. Znane napake v elektroniki, motorju ali vzdrževanju, ki potrebujejo pozornost.",
            info_fit: "Ali avto ustreza vašim potrebam (prostor, udobje)? Slaba prilegajočnost pomeni, da ga boste verjetno zamenjali.",
            info_joy: "Čustvena vrednost je pomembna. Brez veselja pomeni, da ste mentalno pripravljeni na nov avto.",
            info_worry: "Perceived reliability stress. Visoka skrb je močan signal za zamenjavo avta.",
        },
        explanations: {
            repairFreq: "Vaš avto je imel {visits} obiskov servisa v zadnjih 12 mesecih. Pogosti obiski kažejo na nižjo zanesljivost in večje težave.",
            repairVsValue: "V zadnjih 12 mesecih so vaša popravila stala €{cost}, medtem ko je ocenjena vrednost avtomobila €{value}. To je {ratio}% skupne vrednosti avtomobila.",
            stableRepairsDetailYearly: "Lani ste porabili €{cost1} za popravke, leto prej pa €{cost2}. Sprememba {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "V zadnjih 6 mesecih ste porabili €{cost1}, v prejšnjih 6 mesecih pa €{cost2}. Sprememba {percent}% ({trend}).",
            mileage: "Pri {mileage} km avto vstopa v območje višjega tveganja za večje okvare delov (menjalnik, motorne komponente).",
            planned: "Imate €{cost} v načrtovanih popravilih, kar takoj zmanjšuje finančno varnost obdržanja avtomobila.",
            lowDep: "Avtomobili, katerih vrednost je okoli €{value}, izgubljajo zelo malo vrednosti na leto, kar uravnava višje stroške popravil.",
            depRisk: "Vaš avto je star {age} let in je večinoma zaključil svoj amortizacijski cikel, kar pomeni, da ne izgubljate denarja zaradi padca njegove vrednosti.",
            stable: "Porabili ste €{costThisYear} letos v primerjavi z €{costLastYear} lani, kar je {percent}% zmanjšanje. Predvidljivi stroški so matematično ugodni.",
            costKm: "Lani ste prevozili {km} km. Stroški delovanja so bili €{costKm} na kilometer, kar kaže na odlično ekonomsko učinkovitost.",
            fixedCosts: "Plačali ste €{costs} v fiksnih letnih stroških (zavarovanje/davek). Ta nizka obremenitev daje dodatno mirnost.",
            usage: "Na podlagi vaših zapisov vozite okoli {km} km na leto.",
            practical_fit: "Praktično ustreznost ste ocenili na {score}/5, kar je prilagodilo matematično oceno za {impact} točk.",
            emotional_satisfaction: "Čustveno zadovoljstvo ste ocenili na {score}/5, kar je prilagodilo oceno za {impact} točk.",
            reliability_anxiety: "Vaša zanesljivost je {score}/5, kar vpliva na oceno za {impact} točk.",
            rust: "Huda strukturna ali podvozna rja običajno pomeni varnostne nevarnosti ali scenarije za odpis.",
            accident: "Prejšnje poškodbe, odvisno od resnosti, inherentno znižujejo vrednost in varnost vozila.",
            structural: "Strukturne težave avtomobil avtomatsko naredijo finančno nevarnega.",
            ai_lifespan: "Pri {current} km je avto opravil {ratio}% svoje AI ocenjene življenjske dobe ({expect} km).",
            ai_repairs: "Podatki AI kažejo, da se pri tej kilometrini običajno zgodi {count} tipičnih večjih popravil specifičnih za model.",
            lifecycle_stage: "Kaj pomeni življenjska doba? {total} km – to je točka, ki jo napoveduje AI, ko se običajno začnejo večja strukturna popravila (motor, menjalnik itd.) za ta model. To ni konec življenja avtomobila – avto lahko še vedno vozi, vendar z znatno višjimi stroški vzdrževanja. Tipična polna fizična življenjska doba avtomobila je 500k–1M km, vendar postane ekonomsko nevzdržna veliko prej.",
        },
        ratios: {
            healthy: "Zdrav",
            monitor: "Nadzor",
            highRisk: "Visoko tveganje",
            stable: "Stabilno",
            warning: "Opozorilo",
            financialStress: "Finančni stres",
        },
        proFeatureTitle: "Pro funkcija: Način popravila",
        proFeatureDesc: "Odklenite odločilni motor za pridobitev profesionalne finančne analize vaših popravkov vozila. Brezplačni uporabniki vidijo demonstracijo s primeri podatkov.",
        viewDemo: "Ogled žive demonstracije",
        upgradeToUnlock: "Nadgradite na PRO za analizo vašega avtomobila",
    },
    carTasks: {
        title: "Naloge za avtomobil",
        placeholderTitle: "Sledenje vzdrževanju",
        placeholderDesc: "Načrt vzdrževanja za vaš model avtomobila.",
        demoTitle: "Naloge za vzdrževanje avtomobila",
        demoSubtitle: "Pametno sledenje za vaše vozilo",
        feature1Title: "Avtomatizirana generacija nalog",
        feature1Desc: "Samodejno generira naloge, kot so menjave olja, zamenjave filtrov in pregledi zobatega jermena na podlagi modela vašega avtomobila.",
        feature2Title: "Integracija stroškov",
        feature2Desc: "Analizira vašo zgodovino storitev, da razume, kaj je že bilo opravljeno in kdaj.",
        feature3Title: "Pametni opomniki",
        feature3Desc: "Obveščeni boste na podlagi časa in prevoženih kilometrov. Sledenje se samodejno ponastavi, ko nalogo označite kot opravljeno.",
        getStarted: "Začnite",
        fakeDoorPopupTitle: "Povratne informacije dobrodošle",
        fakeDoorPopupMessage: "Trenutno razvijamo naloge za vzdrževanje avtomobilov. Ta funkcija vam bo omogočila samodejno sledenje servisnim intervalom. Katere specifične naloge ali funkcije bi želeli videti najbolj?",
        fakeDoorPopupPlaceholder: "Vaše misli...",
        noTasksYet: "Še ni nalog",
        deleteAllTitle: "Izbriši seznam nalog?",
        deleteAllMessage: "Ali ste prepričani, da želite izbrisati vseh {count} nalog za to vozilo? Te akcije ni mogoče razveljaviti.",
        deleteAllSuccess: "Vse naloge so bile uspešno izbrisane.",
        sortPriority: "Prioriteta",
        sortType: "Tip",
        sortDate: "Najnovejše",
        status: {
            overdue: "ZAMUDENO",
            pending: "ČAKA",
            noData: "NI PODATKOV",
            upcoming: "Prihajajoče",
            nextIn: "Naslednje v {dist} {unit}",
            overdueBy: "{dist} {unit} zamude",
            afterDays: "V {days} dneh",
            overdueDays: "{days} dni zamude",
        },
        form: {
            newTitle: "Nova naloga",
            actionType: "Pregledati ali zamenjati?",
            intervalMonths: "Interval (Meseci)",
            intervalDistance: "Interval (Razdalja)",
            diffFirstInterval: "Prvi interval se razlikuje od osnovnega intervala",
            firstInterval: "Prvi interval",
            historyToggle: "Ali je bila ta naloga kdaj opravljena za to vozilo?",
            historyToggleDesc: "Če NE, predpostavljamo, da še nikoli ni bila opravljena od proizvodnje.",
            lastPerformedOptional: "Kdaj je bila nazadnje opravljena? (Neobvezno)",
            deleteTitle: "Izbriši nalogo",
            deleteConfirm: "Ali ste prepričani, da želite izbrisati to nalogo?",
            saveError: "Ni uspelo shraniti naloge",
            historyConfirmed: "Zgodovina potrjena",
            reminders: "Opomniki",
            notifyMileage: "Obvesti me, ko dosežem predvideno število prevoženih kilometrov",
            notifyDate: "Obvesti me, ko dosežem datum",
            nextMileageReminder: "Predviden datum",
            nextDateReminder: "Rok",
            estimatedDate: "Predviden datum",
            missingLastMileage: "Manjka zadnji opravljeni prevoženi kilometer",
            missingLastDate: "Manjka zadnji opravljeni datum",
            missingStartDate: "Ni mogoče določiti začetnega datuma",
            additionalOptions: "Dodatne možnosti",
            reminderInfoMissing: "Informativno stanje: opomniki so onemogočeni, dokler niso na voljo zadnji izvedeni podatki.",
        },
    },
    dashboard: {
        title: "Nadzorna plošča",
        quickActions: "Hitre akcije",
        addExpense: "Dodaj strošek",
        editCar: "Uredi avto",
        recentExpenses: "Stroški",
        seeAll: "Poglej vse",
        recentGallery: "Datoteke",
        thisMonth: "Ta mesec",
        totalSpent: "Skupaj porabljeno",
        avgPerMonth: "Povp./mesec",
        recentNotes: "Opombe",
        recentParts: "Deli",
        noRecentExpenses: "Brez nedavnih stroškov",
        noRecentGallery: "Brez nedavnih fotografij",
        noRecentNotes: "Brez nedavnih opomb",
        noRecentParts: "Brez nedavnih delov",
        createNote: "Ustvari novo",
        createPart: "Ustvari nov",
        createExpense: "Ustvari nov",
        noFiles: "Še ni dodanih datotek",
        needSomethingMore: "Potrebujete še kaj?",
        letUsKnow: "sporočite nam!",
    },
    expenseTypes: {
        editTitle: "Uredi vrsto stroška",
        newTitle: "Nova vrsta stroška",
        categoryName: "Ime kategorije",
        placeholderName: "npr. Servis",
        signatureColor: "Barva podpisa",
        icon: "Ikona kategorije",
        deleteConfirm: "Ste prepričani, da želite izbrisati vrsto '{name}'?",
    },
    spareParts: {
        title: "Rezervni deli",
        connectedWithRecords: "Povezano z zapisi",
        toBuy: "Za nakup",
        usedInExpenses: "Uporabljeno v stroških",
        noPartsToBuy: "Brez delov dodanih na nakupni seznam",
        noPartsUsed: "Brez delov povezanih s stroški še",
        quantity: "Količina",
        partCode: "Koda dela",
        price: "Cena",
        link: "Povezava",
        comment: "Komentar",
        addPart: "Dodaj rezervni del",
        editPart: "Uredi rezervni del",
        openPart: "Odpri vnos dela",
        nameLabel: "Ime",
        manufacturerLabel: "Proizvajalec",
        priceLabel: "Cena ({currency})",
        imagesLabel: "Datoteke",
        linkedHistory: "Povezana zgodovina",
        partManagedNote: "Ta del se upravlja preko stroška",
        cannotDeleteNote: "Ker je ta del povezan s stroškom, ga ni mogoče izbrisati ločeno. Izbrišite ali uredite strošek, da upravljate življenjski cikel tega dela.",
        partNamePlaceholder: "Ime dela...",
        manufacturerPlaceholder: "Bosch, Brembo, itd.",
        additionalInfoPlaceholder: "Dodatne informacije...",
        namePlaceholder: "npr. Zavorne ploščice",
        codePlaceholder: "npr. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Shrani del",
        deletePart: "Izbriši rezervni del",
        deleteConfirm: "Ste prepričani, da želite izbrisati ta rezervni del?",
        sparePartsLabel: "Rezervni deli",
        partNumber: "Del #{number}",
        imagesLimitLabel: "Datoteke (do 5)",
        optional: "(neobvezno)",
        selectPart: "Izberite rezervni del",
        createNew: "Ustvari nov rezervni del",
        searchPlaceholder: "Išči po imenu ali kodi...",
        noResults: "Brez najdenih delov",
        noPartsYet: "Še ni delov. Ustvarite svojega prvega!",
        selectorDescription: "Najdite in izberite obstoječ rezervni del ali ustvarite novega",
        alreadyAdded: "Ta del je že dodan",
        statistics: {
            avgPrice: "Povp.",
            lastPrice: "Zadnja",
            usedTimes: "Uporabljeno {count} krat",
            totalPurchased: "Skupaj: {quantity}x",
        },
        usage: {
            title: "Ta nakup",
            quantity: "Količina",
            pricePerUnit: "Cena na enoto",
            comment: "Komentar",
            commentPlaceholder: "npr., Kupljeno pri AutoZone",
            total: "Skupaj",
            transactionData: "Ta transakcija",
        },
        masterData: "Glavne informacije o delu",
        masterRecord: {
            title: "Podrobnosti o delu (skupne)",
            editMaster: "Uredi glavni zapis",
            warning: "Spremembe v glavnem zapisu vplivajo na vse uporabe",
        },
    },
    reminders: {
        title: "Opomniki",
        reminder: "Opomnik",
        noteReminder: "Opomnik za opombo",
        partReminder: "Opomnik za del",
        today: "Danes",
        tomorrow: "Jutri",
        yesterday: "Včeraj",
        inXDays: "čez {x} dni",
        xDaysAgo: "pred {x} dnevi",
        inXMonths: "čez {x} mesecev",
        xMonthsAgo: "pred {x} meseci",
        active: "Aktivno",
        activeDesc: "Če je potrebno, lahko ta opomnik izklopite brez brisanja",
        disabled: "Onemogočeno",
        yearly: "Letno",
        markSeen: "Potrdi",
        addReminder: "Nov opomnik",
        editReminder: "Uredi opomnik",
        extraReminders: "Dodatni opomniki",
        extraRemindersDesc: "Pošlji še 3 opomnike v naslednjih dneh (skupaj 4), če ne bo ustavljeno.",
        remindDate: "Datum",
        remindTime: "Čas",
        repeatYearly: "Ponovi letno",
        repeatYearlyDesc: "Ta opomnik se bo samodejno pojavljal vsako leto na isti datum/mesec/dan/čas, dokler ne bo onemogočen",
        standalone: "Samostojni opomniki",
        embedded: "Povezani opomniki",
        noReminders: "Brez aktivnih opomnikov",
        deleteReminder: "Izbriši opomnik",
        nameLabel: "Ime",
        descriptionLabel: "Opis",
        namePlaceholder: "Ime opomnika",
        descriptionPlaceholder: "Kratak opis ali opomba",
        simulateReminder: "Simuliraj trenutek opomnika",
        simulateSuccess: "E-pošta simulacije poslana",
        timezone: "Časovni pas",
        nextReminder: "Naslednji opomnik",
        futureTimeError: "Čas opomnika mora biti v prihodnosti",
    },
    notes: {
        title: "Opombe",
        emptyNote: "Prazna opomba",
        noNotes: "Še ni opomb",
        addNote: "Dodaj opombo",
        editNote: "Uredi opombo",
        viewNote: "Ogled opombe",
        openNote: "Odpri vnos opombe",
        titleLabel: "Naslov",
        contentLabel: "Vsebina",
        noteTitlePlaceholder: "Naslov opombe...",
        noteContentPlaceholder: "Tukaj napišite svojo opombo...",
        saveNote: "Shrani opombo",
        deleteNote: "Izbriši opombo",
        publicNote: "Naredi opombo javno",
        publicNoteDesc: "Drugi lahko vidijo to opombo preko deljene povezave",
        deleteConfirm: "Ali ste prepričani, da želite izbrisati to opombo?",
        enterTitleAlert: "Prosimo, vnesite naslov",
        saveFailed: "Shranjevanje opombe ni uspelo",
        thisNote: "Ta opomba",
        deleteFailed: "Brisanje opombe ni uspelo",
        pinToTop: "Pripni na vrh",
    },
    locations: {
        title: "Lokacije",
        singleTitle: "Lokacija",
        newLocation: "Nova lokacija",
        emptyLocation: "Prazna lokacija",
        noLocations: "Za statistiko - lahko dodate lokacijo, kjer je prišlo do te avtomobilske stroške",
        addLocation: "Dodaj lokacijo",
        editLocation: "Uredi lokacijo",
        viewLocation: "Ogled lokacije",
        openLocation: "Odpri lokacijo",
        createNew: "Ustvari novo lokacijo",
        selectLocation: "Izberi lokacijo",
        searchLocations: "Išči lokacije...",
        nameLabel: "Ime",
        addressLabel: "Naslov ali koordinate",
        descriptionLabel: "Komentar/opis",
        namePlaceholder: "npr., Storitve v središču mesta",
        mapLabel: "Lokacija",
        searchPlaceholder: "Išči naslov...",
        addressPlaceholder: "Vnesite naslov in izberite...",
        descriptionPlaceholder: "Dodatne informacije...",
        fillAddress: "Izpolni naslov iz zemljevida",
        saveLocation: "Shrani lokacijo",
        deleteLocation: "Izbriši lokacijo",
        deleteConfirm: "Ali ste prepričani, da želite izbrisati to lokacijo?",
        enterNameAlert: "Prosimo, vnesite ime",
        saveFailed: "Shranjevanje lokacije ni uspelo",
        thisLocation: "Ta lokacija",
        deleteFailed: "Brisanje lokacije ni uspelo",
        myLocations: "Moje lokacije",
        usedInEntries: "Uporabljeno v vnosih",
        noEntries: "Lokacija ni uporabljena",
        noEntriesThisCar: "Ta lokacija ni bila uporabljena za to vozilo",
        removeLocation: "Odstrani lokacijo",
        noResults: "Ni najdenih rezultatov",
    },
    gallery: {
        title: "Datoteke",
        noImages: "Ni dodanih slik",
        addImagesNote: "Dodajte slike avtomobila ali stroškov",
        totalImages: "Skupaj {count} slik",
        imageAlt: "Slika {number}",
        commentPlaceholder: "Komentar datoteke",
        isReceipt: "Ta datoteka je račun",
        deleteImageTitle: "Izbriši datoteko",
        deleteImageConfirm: "Ste prepričani, da želite trajno izbrisati to datoteko?",
    },
    search: {
        placeholder: "Išči stroške, dele, opombe...",
        typeToSearch: "Vnesite za začetek iskanja",
        noResults: "Ni najdenih rezultatov za '{query}'",
        carImage: "Slika avtomobila",
        expenseImage: "Slika stroška",
        noteImage: "Slika opombe",
        galleryImage: "Slika galerije",
        untitledExpense: "Neimenovani strošek",
    },
    landing: {
        nav: {
            features: "Funkcije",
            howItWorks: "Kako deluje",
            pricing: "Cenik",
            login: "Prijava",
            getStarted: "Začni",
            garage: "Garaža",
        },
        hero: {
            title: "Natančno vedite, koliko stane vaš avto",
            subtitle: "Resnično",
            description: "Spremljajte stroške, beležite popravila in poglejte, kam gre vaš denar.",
            subheadline: "Profesionalna nadzorna plošča, usmerjena v podatke, za natančne lastnike avtomobilov.",
            startTracking: "Začni",
            viewDemo: "Demo Avto ->",
            trustSignal: "Pridružite se 1.200+ natančnim lastnikom, ki so že zabeležili več kot 5 milijonov kilometrov realnih stroškov avtomobilov.",
            ctaNote: "Brez kreditne kartice. Brez vsiljive prodaje. Le jasnost.",
            benefits: {
                repairVsSell: {
                    title: `Popravilo proti prodaji`,
                    description: `Ugotovite prag "Popravilo proti prodaji" — Ne sprašujte se več, ali vlagate denar v brezno. Poznajte natančen trenutek, ko popravilo ni več pametna naložba.`
                },
                costPerKm: {
                    title: `Strošek na KM`,
                    description: `Spremljajte svoj pravi strošek na kilometer — Pojdite onkraj nadzorne plošče. Oglejte si celotno finančno sliko vaših voznih navad, ki jo druge aplikacije spregledajo.`
                },
                automation: {
                    title: `Avtomatizacija`,
                    description: `Avtomatizirajte svoje beleženje — Preprosto posredujte svoje račune ali preprosto pošljite svoje opombe po e-pošti. Naša umetna inteligenca organizira tehnično zgodovino vašega avtomobila namesto vas.`
                }
            },
        },
        features: {
            title: "Vse, kar potrebujete za upravljanje vašega avtomobila",
            subtitle: "Prenehajte uporabljati preglednice in zmedene mape. My Car Costs prinaša profesionalna orodja za upravljanje flote v vaš osebni garaži.",
            expenseTracking: {
                title: "Sledenje stroškom",
                description: "Zabeležite gorivo, storitve, zavarovanje in popravila. Kategorizirajte stroške in vizualizirajte trende porabe skozi čas.",
            },
            spareParts: {
                title: "Upravitelj rezervnih delov",
                description: "Ohranite podroben inventar rezervnih delov, številk delov in opomb o združljivosti za vse vaše popravila.",
            },
            serviceHistory: {
                title: "Zgodovina storitev in opombe",
                description: "Vzdržujte digitalno servisno knjigo. Dodajte podrobne opombe o vzdrževanju, spremembah ali prihodnjih načrtih.",
            },
            documentStorage: {
                title: "Shranjevanje dokumentov",
                description: "Naložite račune, fakture in fotografije vašega avtomobila. Ohranite vso dokumentacijo varno in dostopno.",
            },
            emailForwarding: {
                title: "Preusmerjanje e-pošte",
                description: "Preusmerite račune neposredno v svojo edinstveno e-pošto. Izvlečemo podatke in jih samodejno dodamo na vaš nadzorni plošči.",
            },
            multiCar: {
                title: "Garaža za več avtomobilov",
                description: "Upravljajte en avtomobil ali celo floto. Takoj preklapljajte med vozili in si oglejte agregirane statistike.",
            },
            repeatingExpenses: {
                title: "Ponavljajoči se stroški",
                description: "Avtomatizirajte sledenje rednim mesečnim stroškom, kot so zavarovanje, parkiranje ali leasing.",
            },
            smartReminders: {
                title: "Pametni opomniki",
                description: "Nastavite prilagojene opomnike za rezervne dele in servisne opombe, da nikoli ne zamudite naloge vzdrževanja.",
            },
        },
        howItWorks: {
            title: "Enostaven, močan delovni postopek",
            step1: {
                title: "Dodajte svoje vozilo",
                description: "Vnesite podatke o svojem avtomobilu, da ustvarite svojo digitalno garažo.",
            },
            step2: {
                title: "Zabeležite stroške in datoteke",
                description: "Naredite fotografijo računa ali preusmerite e-pošto. Mi poskrbimo za ostalo.",
            },
            step3: {
                title: "Pridobite vpoglede",
                description: "Oglejte si svoje stroške na kilometer, mesečne stroške in časovnico vzdrževanja.",
            },
        },
        useCases: {
            title: "Popolno za",
            enthusiasts: {
                title: "Avtomobilski navdušenci",
                description: "Sledite vsaki spremembi, številki dela in intervalu vzdrževanja za vaš projektni avto.",
            },
            dailyDrivers: {
                title: "Dnevni vozniki",
                description: "Natančno vedite, koliko stane vaše vsakodnevno potovanje in nikoli ne zamudite datuma storitve.",
            },
            flippers: {
                title: "Pametni preprodajalec",
                description: "Ustvarite preverljivo količino podatkov, ki dokazujejo pravo vrednost vašega avtomobila za kupce.",
            },
            fleets: {
                title: "Majhne flote",
                description: "Upravljajte več podjetniških vozil na enem mestu brez bloata podjetniške programske opreme.",
            },
        },
        foundersNote: {
            title: "Opomba ustanovitelja",
            content: "Gradim MyCarCosts, da bo končno orodje za ljudi, ki jim je mar za njihova vozila. Ali vam manjka kakšna funkcija v vašem delovnem toku? Kontaktirajte me neposredno. Če bo smiselno za skupnost, jo bomo zgradili skupaj.",
        },
        pricing: {
            freeLimitedTime: "Brezplačno za omejen čas",
            title: "Enostaven, pregleden cenik",
            subtitle: "Začnite brezplačno, nadgradite, ko rasteš.",
            perMonth: "mesec",
            monthly: "Mesečno",
            yearly: "Letno",
            save25: "Prihranite 25%",
            billedAnnually: "Zaračunano letno ({amount})",
            free: {
                title: "Brezplačno",
                cta: "Začni zdaj",
            },
            pro: {
                title: "Pro",
                cta: "Nadgradi na Pro",
                recommended: "Priporočeno",
                earlyAdopter: "Cene za zgodnje uporabnike",
                priceLock: "Zakleni to ceno zdaj. Cena se lahko v prihodnosti poveča.",
            },
            custom: {
                title: "Custom",
                cta: "Kontaktirajte nas",
            },
            features: {
                oneCar: "1 avto",
                unlimitedExpenses: "Brez omejitev stroškov",
                unlimitedSpareParts: "Neomejeni rezervni deli",
                unlimitedNotes: "Neomejene opombe",
                repeatedExpenses: "Ponovljeni stroški",
                emailReminders: "Opomniki za opombe in rezervne dele po e-pošti",
                basicStatistics: "Osnovna statistika",
                fullStatistics: "Polna statistika",
                storage50mb: "50 Mb prostora za shranjevanje",
                unlimitedArchivedCars: "Neomejena arhivirana vozila",
                dataExport: "Izvoz podatkov",
                allInFreePlus: "vse v brezplačnem plus:",
                threeCars: "Do 3 avtomobile",
                storage2gb: "2 Gb prostora za shranjevanje",
                emailParsing: "Obdelava e-pošte",
                carAdmins: "Upravitelji avtomobilov",
                moreCars: "Več avtomobilov",
                moreFileStorage: "Več prostora za shranjevanje datotek",
                customRequirements: "Prilagojene zahteve",
            },
            upgradePopup: {
                title: "Kmalu na voljo!",
                message: "Pro in prilagojene različice še niso na voljo, vendar bodo kmalu. Da nam pomagate hitreje zagnati - prosimo, zapišite, katero specifično funkcijo pričakujete od pro / prilagojene različice, ali karkoli drugega, kar bi želeli, da izboljšamo, da bo ta platforma še boljša za vas!",
                placeholder: "Zapišite svoje povratne informacije tukaj...",
                submit: "Pošlji",
                cancel: "Prekliči",
                thanksTitle: "Hvala!",
                thanksMessage: "Prejeli smo vaše povratne informacije in delali bomo na tem, da bo MyCarCosts še boljši!",
                thanksOk: "V redu",
            },
        },
        migration: {
            title: "Prehajate iz Excela ali druge aplikacije?",
            subtitle: "Ponujamo profesionalno storitev migracije podatkov, da vas takoj postavimo v pogon.",
            pricingModel: "Model cen",
            small: {
                title: "Majhen nabor podatkov",
                description: "< 500 vrstic",
                price: "$19–29",
            },
            medium: {
                title: "Srednji nabor podatkov",
                description: "500–5,000 vrstic",
                price: "$49",
            },
            large: {
                title: "Velik / Zmešan",
                description: "Zastarali sistemi ali kompleksne datoteke",
                price: "Prilagojena ponudba",
            },
            process: {
                title: "Kako deluje",
                step1: "Predložite svojo datoteko",
                step2: "Ocenimo podatke",
                step3: "Enkratno plačilo",
                step4: "Skrbimo za uvoz",
            },
            cta: "Zahtevajte migracijo",
        },
        repairAnalysisSection: {
            title: "Popraviti ali prodati? Naj podatki odločijo.",
            subtitle: "Profesionalna finančna analiza za vaše vozilo. Prenehajte ugibati in začnite vedeti, ali so ti popravki resnično vredni.",
            features: {
                personalized: {
                    title: "Personalizirana analiza",
                    description: "Za vaše spremljane avtomobile uporabljamo resnične zgodovinske stroške in parametre ter dodajamo načrtovane stroške za ustvarjanje ocene.",
                },
                public: {
                    title: "Javni simulator",
                    description: "Ocenjujete morebitni nakup? Uporabite naš javni pripomoček na /repair za ustvarjanje podrobne analize z vnosom le nekaj ključnih podatkov.",
                },
                whatIf: {
                    title: "Simulator Kaj-če",
                    description: "Vnesite načrtovane stroške popravila in takoj vidite, kako vplivajo na finančno oceno vašega avtomobila.",
                },
            },
            cta: "Ogled vzorčne analize",
        },
        faq: {
            title: "Pogosto zastavljena vprašanja",
            subtitle: "Vse, kar morate vedeti o My Car Costs",
            questions: {
                mobileApps: {
                    question: "Bodo na voljo aplikacije za iOS in Android?",
                    answer: "Da! Mobilne aplikacije za iOS in Android prihajajo kmalu. Trdo delamo, da vam prinesemo najboljšo mobilno izkušnjo.",
                },
                dataPrivacy: {
                    question: "Ali so moji podatki zasebni in varni?",
                    answer: "Absolutno. Vaši podatki so šifrirani in shranjeni varno. Samo vi lahko dostopate do informacij o vašem avtomobilu, razen če se izrecno odločite, da jih naredite javne.",
                },
                freePlan: {
                    question: "Ali je brezplačni načrt res brezplačen za vedno?",
                    answer: "Da! Brezplačni načrt bo vedno na voljo z enim avtomobilom in vsemi osnovnimi funkcijami. Kdajkoli se lahko nadgradite na Pro za do 3 avtomobile in napredne funkcije.",
                },
                dataExport: {
                    question: "Ali lahko izvozim svoje podatke?",
                    answer: "Da, svoje podatke lahko izvozite kadarkoli v formatu CSV ali PDF. Vaši podatki so vaši in nikoli niste zaklenjeni.",
                },
                emailImport: {
                    question: "Kako deluje uvoz e-pošte?",
                    answer: "Vsak avto dobi edinstven e-poštni naslov. Preprosto posredujte svoje račune in podatke bomo samodejno pridobili.",
                },
                multipleUsers: {
                    question: "Ali lahko več ljudi dostopa do istega avtomobila?",
                    answer: "Trenutno vsak avto pripada enemu računu. Vendar pa lahko avto naredite javno dostopen, da delite dostop samo za branje z drugimi.",
                },
            },
        },
        cta: {
            title: "Ne ugibajte. Vedite.",
            subtitle: "Spremenite zgodovino svojega avtomobila v jasne finančne odločitve. Pridružite se tisočem pametnih lastnikov, ki natančno vedo, kdaj investirati ali prodati.",
            button: "Začni zdaj",
            note: "Brez kreditne kartice. Brez vsiljive prodaje. Le jasnost.",
        },
        footer: {
            product: "Izdelek",
            legal: "Pravno",
            changelog: "Zgodovina sprememb",
            privacy: "Politika zasebnosti",
            contact: "Kontakt",
            contactEmail: "info@mycarcosts.com",
            questions: "Imate vprašanja? Kontaktirajte nas na:",
        },
        privacy: {
            title: "Politika zasebnosti",
            lastUpdated: "Zadnja posodobitev: 25. marec 2026",
            introduction: "Pri My Car Costs resno jemljemo vašo zasebnost. Ta politika pojasnjuje, kako ravnamo z vašimi podatki v skladu s standardi zasebnosti, vključno z GDPR.",
            dataCollection: {
                title: "Zbiranje podatkov",
                description: "Zbiramo le minimalne podatke, potrebne za zagotavljanje naših storitev.",
                email: "Identiteta računa: Vaš e-poštni naslov uporabljamo kot edinstven identifikator in za avtentikacijo (npr. čarobne povezave ali prijavo z Googlom).",
                documents: "Shranjevanje dokumentov: Datoteke, ki jih naložite, so varno shranjene v šifriranem oblaku.",
            },
            carData: {
                title: "Vaš nadzor nad podatki",
                description: "Vneseni podatki (stroški, kilometrina, deli) se hranijo za vašo osebno uporabo in analizo.",
                noValidation: "Ne preverjamo podatkov o vozilu, ki jih vnesete; za njihovo točnost ste odgovorni sami.",
                privateByDefault: "Vaši podatki so privzeto zasebni. Tehnični identifikatorji datotek niso zaporedni in jih iskalniki ne indeksirajo.",
                rightToForgotten: "Pravica do pozabe: Svoj račun lahko kadar koli izbrišete, s čimer se takoj in trajno odstranijo vsi vaši zapisi in datoteke.",
            },
            thirdParty: {
                title: "Storitve tretjih oseb",
                description: "Vaših osebnih podatkov ne prodajamo. Pri uporabi Googlove prijave dostopamo le do vašega e-poštnega naslova za namene identifikacije.",
            },
            emailIngestion: {
                title: "Vnos e-pošte",
                description: "E-poštna sporočila, poslana naši storitvi za vnos, se hranijo za zagotavljanje zgodovine obdelave. Posamezna e-poštna sporočila ali celotno zgodovino lahko kadar koli ročno izbrišete.",
            },
        },
        emails: {
            deleteAll: "Izbriši vse",
            deleteAllConfirm: "Ali ste prepričani, da želite izbrisati celotno zgodovino e-pošte za ta avtomobil? To dejanje je nepovratno.",
            deleteConfirm: "Ali ste prepričani, da želite izbrisati to e-pošto?",
            noEmails: "Ni še prejetih e-poštnih sporočil.",
        },
        terms: {
            title: "Splošni pogoji uporabe",
            lastUpdated: "Zadnja posodobitev: 25. marec 2026",
            introduction: "Z dostopom do ali uporabo MyCarCosts se strinjate, da vas zavezujejo ti Splošni pogoji uporabe. Če se ne strinjate, naše storitve ne uporabljajte.",
            acceptance: {
                title: "1. Sprejetje pogojev",
                description: "Ti pogoji predstavljajo pravno zavezujočo pogodbo med vami in MyCarCosts glede vaše uporabe naše aplikacije in storitev.",
            },
            service: {
                title: "2. Opis storitve",
                description: "MyCarCosts zagotavlja platformo za sledenje stroškov vozila, upravljanje vzdrževanja in finančno analizo. To vključuje AI analizo računov in orodja za vizualizacijo podatkov.",
            },
            responsibilities: {
                title: "3. Odgovornosti uporabnika",
                description: "Odgovorni ste za točnost vseh vnesenih podatkov, vključno s kilometrino, VIN številkami in stroški. Svoje prijavne podatke (e-pošta / čarobna povezava) morate varovati in jih ne deliti z nepooblaščenimi osebami.",
            },
            plans: {
                title: "4. Načrti storitev in omejitve",
                description: "Ponujamo brezplačne in Pro načrte z različnimi omejitvami shranjevanja, števila avtomobilov in nalaganj. Pridržujemo si pravico do spremembe teh omejitev ali uvedbe novih naročniških nivojev.",
            },
            disclaimer: {
                title: "5. Zavrnitev odgovornosti in točnost",
                description: "MyCarCosts je informativno in organizacijsko orodje. Ne izobražujemo uradnih certifikatov o stanju vozila. Uporabnik mora podatke o računih, ki jih analizira AI, vedno preveriti glede točnosti.",
            },
            liability: {
                title: "6. Omejitev odgovornosti",
                description: "MyCarCosts se izvaja po načelu 'v videnem stanju' (as-is). Ne odgovarjamo za nobene mehanske težave, finančne izgube ali netočnosti podatkov, ki nastanejo zaradi uporabe naše aplikacije.",
            },
            termination: {
                title: "7. Prekinitev",
                description: "Uporabo storitve lahko kadar koli prekinete in izbrišete svoje podatke. Pridržujemo si pravico do suspenza ali zaprtja računov, ki kršijo te pogoje ali kažejo zlorabo.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

